export * from './config-label.pipe';
